// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__32Kk7","form":"styles_form__2G8u_"};